import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <i className={`ri-bank-card-line text-2xl ${isScrolled ? 'text-[#00A040]' : 'text-white'} w-8 h-8 flex items-center justify-center`}></i>
          <span className={`font-bold text-lg ${isScrolled ? 'text-[#003366]' : 'text-white'}`}>クレカ比較ナビ</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          <Link to="/ranking" className={`text-sm font-medium hover:opacity-80 transition-opacity cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
            ランキング
          </Link>
          <Link to="/comparison" className={`text-sm font-medium hover:opacity-80 transition-opacity cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
            カード比較
          </Link>
          <a
            href="https://www.ad.jacard.cr.mufg.jp/af/?utm_source=affiliate&utm_medium=A8"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#00A040] hover:bg-[#008030] text-white text-sm font-bold px-4 py-2 rounded-lg transition-all cursor-pointer whitespace-nowrap"
          >
            このカードを申込む
          </a>
        </nav>
      </div>
    </header>
  );
}
